<template>
  <div>
    <nav aria-label="breadcrumb" class="content-block">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a href="#/simpeg-dashboard">Dashboard</a>
        </li>
        <li class="breadcrumb-item">
          <a href="#/simpeg-pegawai-list">Daftar Pegawai</a>
        </li>
        <li class="breadcrumb-item active" aria-current="page">
          Daftar Riwayat Pekerjaan
        </li>
      </ol>
    </nav>
    <div class="content-block">
      <h5>Daftar Riwayat Pekerjaan</h5>
    </div>
    <div class="content-block">
      <div class="dx-card responsive-paddings">
        <DxDataGrid
          ref="gridRef"
          id="gridContainer"
          :data-source="dataSource"
          :allow-column-reordering="true"
          :show-borders="true"
          @editor-preparing="oneditorpreparing"
          :focused-row-index="0"
          :show-column-lines="false"
          :focused-row-enabled="true"
          :column-auto-width="true"
          :column-hiding-enabled="false"
          @option-changed="onPageChanged"
          @exporting="onExporting"
          :filter-sync-enabled="true"
          :word-wrap-enabled="true"
          :height="gridHeight"
        >
          <DxExport :enabled="true" />

          <DxToolbar>
            <DxItem location="after" template="refresh-template" />
            <DxItem name="exportButton" />
            <DxItem name="columnChooserButton" />
          </DxToolbar>
          <template #refresh-template>
            <DxButton
              icon="refresh"
              @click="refreshDatagrid('gridRef')"
              text="Refresh Data"
              type="default"
              style="float: left"
              width="160px"
              styling-mode="outlined"
            ></DxButton>
          </template>
          <DxFilterRow :visible="showFilterRow" :apply-filter="currentFilter" />
          <dx-pager :show-page-size-selector="true" :show-info="true" />
          <DxPaging :enabled="true" :page-size="150" />
          <DxEditing
            :allow-updating="false"
            :allow-deleting="false"
            :allow-adding="false"
            mode="row"
          />
          <!-- <DxSelection mode="multiple" /> -->
          <DxColumnFixing :enabled="true" />

          <DxColumn
            caption="#"
            data-field="created_at"
            cell-template="numberingTemplate"
            :allow-filtering="false"
            :allow-sorting="false"
            :allow-exporting="false"
          />

          <template #numberingTemplate="{ data }">
            {{ numberingPageNumber * numberingPageSize + data.rowIndex + 1 }}
          </template>
          <dx-column
            data-field="status"
            caption="Status Pekerjaan"
            cell-template="templateStatus"
            data-type="boolean"
          >
            <DxLookup
              display-expr="nama"
              value-expr="val"
              :data-source="statusSource"
            />
          </dx-column>
          <template #templateStatus="{ data }">
            <StatusTemplate :value="data.value" />
          </template>

          <DxColumn
            data-field="simpegPegawai.nik"
            caption="NIK"
            data-type="string"
          >
          </DxColumn>
          <DxColumn
            data-field="simpegPegawai.nama"
            caption="Pegawai"
            data-type="string"
          >
          </DxColumn>

          <dx-column
            data-field="pegawai_status_id"
            caption="Status Pegawai"
            data-type="number"
          >
            <DxLookup
              display-expr="nama"
              value-expr="id"
              :data-source="pegawaiStatusSource"
            />
            <DxRequiredRuleDataGrid />
          </dx-column>

          <dx-column
            data-field="jabatan_id"
            caption="Jabatan"
            data-type="number"
          >
            <DxLookup
              display-expr="nama"
              value-expr="id"
              :data-source="jabatanSource"
            />
            <DxRequiredRuleDataGrid />
          </dx-column>
          <dx-column data-field="cabang_id" caption="Cabang" data-type="number">
            <DxLookup
              display-expr="nama"
              value-expr="id"
              :data-source="cabangSource"
            />
            <DxRequiredRuleDataGrid />
          </dx-column>
          <dx-column data-field="unit_id" caption="Unit" data-type="number">
            <DxLookup
              display-expr="nama"
              value-expr="id"
              :data-source="unitSource"
            />
          </dx-column>
          <dx-column data-field="bagian_id" caption="Bagian" data-type="number">
            <DxLookup
              display-expr="nama"
              value-expr="id"
              :data-source="bagianSource"
            />
          </dx-column>
          <dx-column
            data-field="sub_bagian_id"
            caption="Sub Bagian"
            data-type="number"
          >
            <DxLookup
              display-expr="nama"
              value-expr="id"
              :data-source="subBagianSource"
            />
          </dx-column>
          <dx-column data-field="bidang_id" caption="Bidang" data-type="number">
            <DxLookup
              display-expr="nama"
              value-expr="id"
              :data-source="bidangSource"
            />
          </dx-column>

          <dx-column
            data-field="sub_bidang_id"
            caption="Sub Bidang"
            data-type="number"
          >
            <DxLookup
              display-expr="nama"
              value-expr="id"
              :data-source="subBidangSource"
            />
          </dx-column>
          <dx-column data-field="seksi_id" caption="Seksi" data-type="number">
            <DxLookup
              display-expr="nama"
              value-expr="id"
              :data-source="seksiSource"
            />
          </dx-column>

          <dx-column
            data-field="tgl_mulai_bekerja"
            caption="Tgl Mulai"
            data-type="date"
            :display-format="'dd/MM/yyyy'"
            :format="'dd/MM/yyyy'"
            editor-type="dxDateBox"
          >
            <DxRequiredRuleDataGrid />
          </dx-column>
          <dx-column
            data-field="tgl_akhir_bekerja"
            caption="Tgl Akhir"
            data-type="date"
            :display-format="'dd/MM/yyyy'"
            :format="'dd/MM/yyyy'"
            editor-type="dxDateBox"
          >
          </dx-column>
          <DxColumn
            :allow-filtering="false"
            :allow-sorting="false"
            :allow-exporting="false"
            :allow-editing="false"
            :allow-adding="false"
            cell-template="fileTemplate"
            caption="Dokumen"
            data-field="file_path"
            data-type="string"
          />

          <template #fileTemplate="{ data }">
            <div class="small-button-container">
              <DxButton
                :visible="setPrintAdaFile(data.text)"
                @click="handleClickDocument(data)"
                icon="download"
              />
            </div>
          </template>

          <dx-column
            cell-template="diff-cell-template"
            :fixed="true"
            fixed-position="right"
            :allow-sorting="false"
            data-field="pegawai_id"
            data-type="number"
            caption=" "
            :allow-exporting="false"
            :allow-filtering="false"
          >
          </dx-column>

          <template #diff-cell-template="{ data }">
            <DxDropDownButton
              :items="options"
              icon="menu"
              :id="data.text"
              :show-arrow-icon="false"
              :drop-down-options="{ width: 100 }"
              @item-click="onItemClick"
            />
          </template>
        </DxDataGrid>
      </div>
    </div>
  </div>
</template>

<style lang="scss"></style>
<script>
import { BASE_URL } from "@/global-constants";
import notify from "devextreme/ui/notify";
import _ from "lodash";
import { ODATA_BASE_URL } from "@/global-constants";
import DxButton from "devextreme-vue/button";
import ODataStore from "devextreme/data/odata/store";
import DataSource from "devextreme/data/data_source";
import router from "@/router";
import DxDropDownButton from "devextreme-vue/drop-down-button";
import {
  DxDataGrid,
  DxColumn,
  DxEditing,
  DxPaging,
  DxFilterRow,
  DxLookup,
  DxPager,
  DxExport,
  DxToolbar,
  DxItem,
} from "devextreme-vue/data-grid";
import StatusTemplate from "./StatusTemplate.vue";
import { exportDataGrid } from "devextreme/excel_exporter";
import { Workbook } from "exceljs";
import saveAs from "file-saver";
import { useJabatanStore } from "@/stores/JabatanStore";
import { useBagianStore } from "@/stores/BagianStore";
import { useBidangStore } from "@/stores/BidangStore";
import { useSubBagianStore } from "@/stores/SubBagianStore";
import { useSubBidangStore } from "@/stores/SubBidangStore";
import { useSeksiStore } from "@/stores/SeksiStore";
import { useCabangStore } from "@/stores/CabangStore";
import { useUnitStore } from "@/stores/UnitStore";
import { usePegawaiStatusStore } from "@/stores/PegawaiStatusStore";

function getUrlFilter() {
  return router.currentRoute.value.query.filter;
}
const options = ["Detail Pegawai", "Absensi", "Riwayat Gaji"];

const dataSource = new DataSource({
  store: new ODataStore({
    // ODataStore is configured here
    url: `${ODATA_BASE_URL}/RiwayatPekerjaans`,
    key: "id",
    version: 4,
    beforeSend: function (e) {
      e.headers = {
        "odata-version": "4.0",
      };
      console.log(e);

      if (typeof e.params.$filter == "undefined") {
        console.log("undefined");
        // e.params.$filter = "month(tgl) eq '5' and year(tgl) eq '2023'";
        e.params.$filter = getUrlFilter();
      }
      if (hasFilterNestedTable(e.params.$filter)) {
        e.params.$filter = convertFilterPegawai(e.params.$filter);
      }
      e.params.$orderby = "pegawai_id asc";
    },
  }),
  expand: ["simpegPegawai"],
});

function hasFilterNestedTable(str) {
  return (
    _.includes(str, "/") ||
    _.includes(str, "[") ||
    _.includes(str, "]") ||
    _.includes(str, "riwayatPekerjaan/") ||
    _.includes(str, "riwayatGolongan/") ||
    _.includes(str, "pegawai/") ||
    _.includes(str, "simpegPegawai/")
  );
}

function convertFilterPegawai(filter) {
  var searchTerm = (filter.match(
    /contains\(tolower\(simpegPegawai\/nama\),'([^']+)'/
  ) || [])[1];
  var replacedString = filter.replace(
    /contains\(tolower\(simpegPegawai\/nama\),'([^']+)'/,
    `simpegPegawai/any(s:(contains(tolower(s/nama),'${searchTerm}'))`
  );

  var searchTermNik = (replacedString.match(
    /contains\(tolower\(simpegPegawai\/nik\),'([^']+)'/
  ) || [])[1];
  var replacedStringNik = replacedString;

  replacedStringNik = replacedString.replace(
    /contains\(tolower\(simpegPegawai\/nik\),'([^']+)'/,
    `simpegPegawai/any(s:(contains(tolower(s/nik),'${searchTermNik}'))`
  );

  return replacedStringNik;
}
export default {
  components: {
    DxDataGrid,
    DxColumn,
    DxEditing,
    DxPaging,
    DxFilterRow,
    DxLookup,
    DxPager,
    DxDropDownButton,
    DxButton,
    DxExport,
    DxToolbar,
    DxItem,
    StatusTemplate,
  },
  setup() {
    const jabatanStore = useJabatanStore();
    const bagianStore = useBagianStore();
    const bidangStore = useBidangStore();
    const subBagianStore = useSubBagianStore();
    const subBidangStore = useSubBidangStore();
    const seksiStore = useSeksiStore();
    const cabangStore = useCabangStore();
    const unitStore = useUnitStore();
    const pegawaiStatusStore = usePegawaiStatusStore();
    return {
      jabatanStore,
      bagianStore,
      bidangStore,
      subBagianStore,
      subBidangStore,
      seksiStore,
      cabangStore,
      unitStore,
      pegawaiStatusStore,
    };
  },

  data() {
    return {
      serverUrl: `${BASE_URL}/`,
      pegawaiStatusSource: null,
      jabatanSource: null,
      cabangSource: null,
      unitSource: null,
      bagianSource: null,
      bidangSource: null,
      subBagianSource: null,
      seksiSource: null,

      statusPenyesuaianSource: [
        { val: true, nama: "Penyesuaian" },
        { val: false, nama: "" },
      ],
      statusSource: [
        { val: true, nama: "Aktif" },
        { val: false, nama: "Tidak Aktif" },
      ],
      numberingPageSize: 10,
      numberingPageNumber: 0,
      router: router,
      options: options,
      // pegawaiSource: new ODataStore({
      //   url: "http://127.0.0.1/odata/pegawais",
      //   key: "id",
      // }),
      filterValue: "",
      dataSource,
      editingOptions: {},
      showFilterRow: true,
      currentFilter: [
        {
          key: "auto",
          name: "Immediately",
        },
      ],
      filterOperations: ["=", "<>", ">", "<", "between"],
      calculateFilterExpression: function (
        filterValue,
        selectedFilterOperation,
        target
      ) {
        console.log("calculateFilterExpression filterValue", filterValue);
        console.log(
          "calculateFilterExpression selectedFilterOperation",
          selectedFilterOperation
        );
        console.log("calculateFilterExpression target", target);
        let column = this;
        if (selectedFilterOperation === "=" && target == "filterRow") {
          console.log("calculateFilterExpression", "masuk ==");

          let bulan = filterValue.getMonth() + 1;
          var filterExpression = [
            "month(" +
              column.dataField +
              ") eq " +
              bulan.toString() +
              " and " +
              "year(" +
              column.dataField +
              ") eq " +
              filterValue.getFullYear().toString(),
          ];
          return filterExpression;
        }
        if (selectedFilterOperation === "<>" && target == "filterRow") {
          //notequal
          let bulan = filterValue.getMonth() + 1;
          var filterExpression2 = [
            "month(" +
              column.dataField +
              ") ne " +
              bulan.toString() +
              " and " +
              "year(" +
              column.dataField +
              ") ne " +
              filterValue.getFullYear().toString(),
          ];
          return filterExpression2;
        }
        if (selectedFilterOperation === "<" && target == "filterRow") {
          //less than
          let bulan = filterValue.getMonth() + 1;
          var filterExpression3 = [
            "year(tgl) lt " +
              filterValue.getFullYear().toString() +
              " or (year(tgl) eq " +
              filterValue.getFullYear().toString() +
              " and month(tgl) lt " +
              bulan +
              ")",
          ];
          return filterExpression3;
        }
        if (selectedFilterOperation === ">" && target == "filterRow") {
          //greater than
          let bulan = filterValue.getMonth() + 1;
          var filterExpression4 = [
            "year(tgl) gt " +
              filterValue.getFullYear().toString() +
              " or (year(tgl) eq " +
              filterValue.getFullYear().toString() +
              " and month(tgl) gt " +
              bulan +
              ")",
          ];
          return filterExpression4;
        }

        if (selectedFilterOperation === "between" && target == "filterRow") {
          // (year(Date) eq 2022 and month(Date) ge 5) or (year(Date) eq 2023 and month(Date) le 6)
          let bulan1 = filterValue[0].getMonth() + 1;
          let bulan2 = filterValue[1].getMonth() + 1;

          var filterExpression5 = [
            "month(tgl) ge " +
              bulan1 +
              " and year(tgl) ge " +
              filterValue[0].getFullYear() +
              " and " +
              "month(tgl) le " +
              bulan2 +
              " and year(tgl) le " +
              filterValue[1].getFullYear(),
          ];
          console.log(filterExpression5);
          return filterExpression5;
        }

        // Invokes the default filtering behavior
        return column.defaultCalculateFilterExpression(arguments);
      },
      oneditorpreparing: function (e) {
        console.log("ONEDITORPREPARING");
        console.log(e);
        if (e.dataField === "tgl") {
          e.editorOptions.calendarOptions = {
            minZoomLevel: "year",
            maxZoomLevel: "year",
            displayFormat: "MM/yyyy",
            type: "month",
          };
        }
      },
    };
  },
  async mounted() {
    this.jabatanSource = await this.jabatanStore.get();
    this.bagianSource = await this.bagianStore.get();
    this.bidangSource = await this.bidangStore.get();
    this.subBagianSource = await this.subBagianStore.get();
    this.subBidangSource = await this.subBidangStore.get();
    this.seksiSource = await this.seksiStore.get();
    this.cabangSource = await this.cabangStore.get();
    this.unitSource = await this.unitStore.get();
    this.pegawaiStatusSource = await this.pegawaiStatusStore.get();
  },
  computed: {
    gridHeight() {
      // Calculate grid height based on your requirements
      return "80vh"; // Set the height to fill the viewport vertically
    },
  },
  methods: {
    setPrintAdaFile(e) {
      if (_.isEmpty(e)) return false;
      else return true;
    },

    handleClickDocument(e) {
      this.fileUrl = e.data.file_path;
      this.downloadFile();
    },
    downloadFile() {
      if (this.fileUrl !== null) {
        console.log("ADA FILE DOWNLOAD");
        window.open(this.serverUrl + this.fileUrl, "_blank", "location=yes");
      } else {
        console.log("TIDAK ADA");
        notify("File tidak ada", "error");
      }
    },
    onExporting(e) {
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet("Sheet 1");

      exportDataGrid({
        component: e.component,
        worksheet,
        autoFilterEnabled: true,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(
            new Blob([buffer], { type: "application/octet-stream" }),
            "Daftar Riwayat Pekerjaan.xlsx"
          );
        });
      });
      e.cancel = true;
    },

    refreshDatagrid(gridRef) {
      this.$refs[gridRef].instance.getDataSource().reload();
    },
    onPageChanged(e) {
      if (e.fullName == "paging.pageIndex") {
        this.numberingPageSize = this.$refs.gridRef.instance.pageSize();
        this.numberingPageNumber = e.value;
      }
    },

    onItemClick(e) {
      let pegawaiId = e.element.id;

      if (e.itemData === "Absensi") {
        const url = this.$router.resolve({
          name: "absen-list-custom",
          query: { filter: ["pegawai_id", "=", pegawaiId] },
        }).href;
        window.open(url, "_blank");
      }

      if (e.itemData === "Riwayat Gaji") {
        const url = this.$router.resolve({
          name: "gaji-history-custom",
          query: { filter: ["gajis_pegawai_id", "=", pegawaiId] },
        }).href;
        window.open(url, "_blank");
      }

      if (e.itemData === "Detail Pegawai") {
        const url = this.$router.resolve({
          name: "simpeg-pegawai-detail",
          query: { id: pegawaiId },
        }).href;
        window.open(url, "_blank");
      }
    },
  },
};
</script>
